<template>
  <div class="bottom-banner" @click="$emit('open-form')">
    <div class="banner-link">
      <div class="banner-content">
        <div class="banner-top">
          <span class="approval-tag">사업계획 승인 기념</span>
          <span class="limit-tag">선착순 <strong>50세대</strong></span>
        </div>
        <div class="banner-main">
          <span class="amount">3,000만원 상당</span>
          <span class="separator">·</span>
          <strong class="highlight">필수 옵션 무상 제공</strong>
          <span class="arrow">›</span>
        </div>
      </div>
      <div class="shine-effect"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileBottomBanner',
  emits: ['open-form']
}
</script>

<style scoped>
.bottom-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 980;
}

.banner-link {
  display: block;
  background:
    linear-gradient(90deg, #0a0e1a 0%, #1a2238 50%, #0a0e1a 100%);
  padding: 12px 20px 14px;
  text-decoration: none;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  border-top: 1px solid rgba(212, 175, 55, 0.5);
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.3);
}

/* 상단 골드 라인 */
.banner-link::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 1px;
  background: linear-gradient(90deg,
    transparent 0%,
    rgba(212, 175, 55, 0.6) 20%,
    rgba(212, 175, 55, 1) 50%,
    rgba(212, 175, 55, 0.6) 80%,
    transparent 100%
  );
  animation: borderPulse 2.4s ease-in-out infinite;
}

@keyframes borderPulse {
  0%, 100% { opacity: 0.7; }
  50% { opacity: 1; }
}

.banner-content {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
}

.banner-top {
  display: flex;
  align-items: center;
  gap: 8px;
}

.approval-tag {
  font-size: 11px;
  font-weight: 700;
  color: #d4af37;
  letter-spacing: 0.8px;
  padding: 2px 9px;
  border: 1px solid rgba(212, 175, 55, 0.5);
  border-radius: 2px;
  background: rgba(212, 175, 55, 0.08);
}

.limit-tag {
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  letter-spacing: 0.3px;
}

.limit-tag strong {
  color: #ffd700;
  font-weight: 800;
  font-size: 13px;
  margin: 0 1px;
}

.banner-main {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #fff;
}

.amount {
  font-size: 14px;
  font-weight: 700;
  color: #d4af37;
  letter-spacing: -0.2px;
  text-shadow: 0 0 10px rgba(212, 175, 55, 0.4);
}

.separator {
  color: rgba(212, 175, 55, 0.5);
  font-weight: 700;
}

.highlight {
  font-size: 16px;
  font-weight: 800;
  color: #fff;
  letter-spacing: -0.3px;
  text-shadow: 0 0 12px rgba(255, 255, 255, 0.2);
}

.arrow {
  font-size: 22px;
  font-weight: 300;
  color: #d4af37;
  line-height: 1;
  margin-left: 2px;
  animation: arrow-shift 1.8s ease-in-out infinite;
}

@keyframes arrow-shift {
  0%, 100% { transform: translateX(0); opacity: 0.7; }
  50% { transform: translateX(4px); opacity: 1; }
}

/* 골드 샤이머 */
.shine-effect {
  position: absolute;
  top: 0;
  left: -100%;
  width: 60%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(212, 175, 55, 0.2),
    transparent
  );
  animation: shine 3.5s ease-in-out infinite;
}

@keyframes shine {
  0% { left: -60%; }
  100% { left: 110%; }
}

/* 작은 화면 */
@media (max-width: 380px) {
  .banner-link {
    padding: 11px 14px 13px;
  }
  .approval-tag {
    font-size: 10px;
    padding: 2px 7px;
    letter-spacing: 0.5px;
  }
  .limit-tag {
    font-size: 11px;
  }
  .limit-tag strong {
    font-size: 12px;
  }
  .amount {
    font-size: 12px;
  }
  .highlight {
    font-size: 14px;
  }
  .arrow {
    font-size: 19px;
  }
}
</style>
